import { Card, Col, Divider, Row } from "antd";
import { FunctionComponent } from "react";
import { InputTarif } from "./InputTarifEnfant";

export type InfosTarifProperties = {
    readOnly: boolean;
}

export const InfosTarifEnfant: FunctionComponent<InfosTarifProperties> = ({ readOnly }) => {

    return (
        <>
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Divider orientation="left">Tarifs</Divider>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col xs={24} xl={12}>
                    <Card
                        size="small"
                        title="Adhérents"
                        style={{ borderRadius: '8px', border: '1px solid #e8e8e8' }}
                        headStyle={{ background: '#f6ffed', borderBottom: '1px solid #b7eb8f', fontWeight: 600, color: '#389e0d' }}
                    >
                        <InputTarif labelNbEnfant="1 enfant" nameMontantBase="montantBase1EnfantAdherent" nameMontantEnfant="montantEnfant1EnfantAdherent" readOnly={readOnly} />
                        <InputTarif labelNbEnfant="2 enfants" nameMontantBase="montantBase2EnfantAdherent" nameMontantEnfant="montantEnfant2EnfantAdherent" readOnly={readOnly} />
                        <InputTarif labelNbEnfant="3 enfants" nameMontantBase="montantBase3EnfantAdherent" nameMontantEnfant="montantEnfant3EnfantAdherent" readOnly={readOnly} />
                        <InputTarif labelNbEnfant="4 enfants et +" nameMontantBase="montantBase4EnfantAdherent" nameMontantEnfant="montantEnfant4EnfantAdherent" readOnly={readOnly} />
                    </Card>
                </Col>
                <Col xs={24} xl={12}>
                    <Card
                        size="small"
                        title="Non Adhérents"
                        style={{ borderRadius: '8px', border: '1px solid #e8e8e8' }}
                        headStyle={{ background: '#fff7e6', borderBottom: '1px solid #ffd591', fontWeight: 600, color: '#d46b08' }}
                    >
                        <InputTarif labelNbEnfant="1 enfant" nameMontantBase="montantBase1Enfant" nameMontantEnfant="montantEnfant1Enfant" readOnly={readOnly} />
                        <InputTarif labelNbEnfant="2 enfants" nameMontantBase="montantBase2Enfant" nameMontantEnfant="montantEnfant2Enfant" readOnly={readOnly} />
                        <InputTarif labelNbEnfant="3 enfants" nameMontantBase="montantBase3Enfant" nameMontantEnfant="montantEnfant3Enfant" readOnly={readOnly} />
                        <InputTarif labelNbEnfant="4 enfants et +" nameMontantBase="montantBase4Enfant" nameMontantEnfant="montantEnfant4Enfant" readOnly={readOnly} />
                    </Card>
                </Col>
            </Row>
        </>
    );
}
